import { Col } from 'antd';
import React from 'react';

type Props = {
  label?: String;
  required: boolean;
  column?: boolean;
};

const FormItem: React.FC<Props> = props => {
  const { label, required, column } = props;
  return (
    <div className={`form-item ${column ? 'form-item-column' : ''}`}>
      <Col lg={7} md={24} sm={24} xs={24} style={{ maxWidth: '205px' }}>
        <label>
          {label} <span>{required ? ' *' : ''}</span>
        </label>
      </Col>
      <Col lg={17} md={24} sm={24} xs={24} style={{ maxWidth: '515px' }}>
        {props.children}
      </Col>
    </div>
  );
};

export default FormItem;
